<template>
    <div id="cb4x-content">
        <h4>{{ headerBlock.title }}</h4>
        <p>
            <ob1-capsule
                :is-information="true"
                :label="headerBlock.feesLabel"
            />
            <strong>{{ headerBlock.subTitle }}</strong>
        </p>

        <div id="widget-oney" :style="widgetLoaded ? '' : 'display: none;'" />

        <div class="ob1-skeleton widget-skeleton" :style="{ display: widgetLoaded ? 'none' : ''}">
            <div class="d-flex">
                <div class="me-auto justify-content-start ob1-skeleton-white" style="width: 130px; height: 20px" />
                <div class="justify-content-end ob1-skeleton-white" style="width: 70px; height: 20px" />
            </div>
            <hr class="separator my-1 separator--gray4">
            <div class="d-flex ">
                <div class="me-auto justify-content-start ob1-skeleton-white" style="width: 80px; height: 20px" />
                <div class="justify-content-end ob1-skeleton-white mb-1" style="width: 70px; height: 20px" />
            </div>
            <div class="d-flex ">
                <div class="me-auto justify-content-start ob1-skeleton-white" style="width: 160px; height: 20px" />
                <div class="justify-content-end ob1-skeleton-white mb-1" style="width: 70px; height: 20px" />
            </div>
            <div class="d-flex ">
                <div class="me-auto justify-content-start ob1-skeleton-white" style="width: 150px; height: 20px" />
                <div class="justify-content-end ob1-skeleton-white mb-1" style="width: 50px; height: 20px" />
            </div>
            <div class="d-flex ">
                <div class="me-auto justify-content-start ob1-skeleton-white" style="width: 50px; height: 20px" />
                <div class="justify-content-end ob1-skeleton-white mb-1" style="width: 50px; height: 20px" />
            </div>
        </div>

        <div v-if="illustration" class="row pt-2 pb-1">
            <ob1-picture :visual="illustration" class="illustration" css-classes="d-block mx-auto" />
        </div>
        <!--Bloc comment profiter-->
        <template v-if="howToBenefit">
            <div class="bg-gray2 px-2 pb-1 mb-1 mb-md-2">
                <p class="mb-0">
                    <span class="lead">
                        <strong>{{ howToBenefit.title }}</strong>
                    </span>
                    <br>
                    <strong>{{ howToBenefit.subTitle }}</strong>
                </p>
                <p
                    v-for="(howToBenefitText, index) in howToBenefit.texts"
                    :key="'how-to-'+index"
                    class="d-flex align-items-center mb-0"
                >
                    <span class="font-size-24" :class="'icon-number-' + getIndex(index) +'-wired'" aria-hidden="true" />
                    <span class="ms-1" v-html="howToBenefitText" />
                </p>
            </div>
            <div v-if="howToBenefit.link" class="text-center mt-2 mb-4">
                <ob1-boutons
                    :label="howToBenefit.link.label"
                    :href="howToBenefit.link.url"
                    :target="'_blank'"
                    :is-button="false"
                    is-secondary
                />
            </div>
        </template>

        <ob1-liens-haut-bas
            :is-collapsed="false"
            collapsed-block-id="legal-mentions-4xcb-block"
            :button-label="cgu.title"
            button-id="legal-mentions-4xcb-link"
        >
            <p v-html="cgu.text" />
        </ob1-liens-haut-bas>
    </div>
</template>
<script>

export default {
    name: 'Cb4xModalContent',
    props: {
        modalId: {
            type: String,
            required: true
        },
        amount: {
            type: Number,
            required: true
        },
        counterDelay: {
            type: Number,
            required: true
        },
        oneyWidgetSrc: {
            type: String,
            required: true
        },
        oneyMerchantGuid: {
            type: String,
            required: true
        },
        illustration: {
            type: Object,
            required: false,
            default: undefined
        },
        headerBlock: {
            type: Object,
            required: true
        },
        howToBenefit: {
            type: Object,
            required: false,
            default: undefined
        },
        cgu: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            firstFundingDetailsDisplay: true,
            widgetLoaded: false,
            handleWidgetTimer: null,
            checkWidgetLoadedTimer: null
        }
    },
    mounted() {
        $(`#${this.modalId}`).on("show.bs.modal", this.loadWidget);
        $(`#${this.modalId}`).on("hide.bs.modal", () => {
            if (this.handleWidgetTimer) {
                clearInterval(this.handleWidgetTimer);
                this.handleWidgetTimer = null;
            }
            if (this.checkWidgetLoadedTimer) {
                clearInterval(this.checkWidgetLoadedTimer);
                this.checkWidgetLoadedTimer = null;
            }
        });
    },
    beforeDestroy() {
        $(`#${this.modalId}`).off('show.bs.modal', this.loadWidget);
    },
    methods: {
        loadWidget(){
            this.handleWidgetDisplay();
            this.checkWidgetLoaded();
        },
        addOneyScript() {
            const url = new URL(this.oneyWidgetSrc);
            const oneyScript = document.createElement("script");
            oneyScript.setAttribute("type", "application/javascript");
            oneyScript.setAttribute("defer", "");
            oneyScript.setAttribute("src", url.toString());
            document.head.appendChild(oneyScript);
        },
        loadOneyWidgetMethod(options) {
            loadOneyWidget(function () {
                oneyMerchantApp.loadCheckoutSection({options});
            });
        },
        handleWidgetDisplay() {
            if (this.firstFundingDetailsDisplay) {
                this.addOneyScript();
            }
            const options = {
                country: "FR",
                language: "FR",
                merchant_guid: this.oneyMerchantGuid,
                payment_amount: this.amount,
                filter_by: "filters",
                hide_logo: true,
                filters: [{
                    "payment_method": "bnpl",
                    "payment_method_type": "split",
                    "payment_mode": "4x",
                    "with_down_payment": "true",
                    "is_free": false
                }],
                checkout_placeholder: "#widget-oney"
            };
            options.errorCallback = function (status, response) {
                console.log('widget loading error:' + status + " - " + response);
            };
            if (this.firstFundingDetailsDisplay) {
                // Timer utilisé pour charger du widget dès que le script Oney a été chargé.
                // L'algo est le suivant :
                // - on crée un timer récurrent de n ms,
                // - quand le timer tombe, on regarde si la méthode du script oney est présente dans la page
                // - si la méthode du script oney est présente dans la page, on peut l'appeler
                const wait = this.counterDelay;
                this.handleWidgetTimer = setInterval(() => {
                    if (typeof loadOneyWidget === "function") {
                        this.loadOneyWidgetMethod(options);
                        this.firstFundingDetailsDisplay = false;
                        clearInterval(this.handleWidgetTimer);
                        this.handleWidgetTimer = null;
                    }
                }, wait);
            } else {
                this.loadOneyWidgetMethod(options);
            }

        },
        getIndex: function (index) {
            return index + 1;
        },
        checkWidgetLoaded: function () {
            this.widgetLoaded = false;
            const childElements = document.getElementById('widget-oney').children;

            this.checkWidgetLoadedTimer = setInterval(() => {
                for (const childElement of childElements) {
                    if (childElement.textContent.includes('€')) {
                        this.widgetLoaded = true;
                        clearInterval(this.checkWidgetLoadedTimer);
                        this.checkWidgetLoadedTimer = null;
                        break;
                    }
                }
            }, 500);
        }

    }
}
</script>

<style lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

#widget-oney button {
    display: none;
}
.illustration > img {
    height: px-to-rem(178);
}

.widget-skeleton {
    padding: 30px 10px 23px;
    @media (max-width: #{map-get($grid-breakpoints, xl)}) {
        padding-bottom: 28px;
    }
}

</style>
